import { Button } from "@/components";
import { ReportSummary } from "@/types";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate, useParams } from "react-router-dom";
import "./style.scss";
interface Props {
  data: ReportSummary;
}
export const RepoNode = ({
  data: { id: reportId, issueCount, title },
}: Props) => {
  const navigate = useNavigate();
  const { taskId = "" } = useParams();

  const handleView = () => {
    navigate(`/task/${taskId}/${reportId}`);
  };
  return (
    <div className="program-node" onClick={handleView}>
      <div>
        <div className="program-node__name">{title}</div>
        <div className="program-node__desc mt-2">
          {issueCount} vulnerabilities
        </div>
      </div>
      <Button color="light" className="ms-auto my-auto" onClick={handleView}>
        View
      </Button>
    </div>
  );
};

export const LoadingRepoNode = () => (
  <div className="program-node">
    <div className="d-flex w-100">
      <div>
        <Skeleton height={20} style={{ width: 160, marginBottom: 4 }} />
        <Skeleton height={16} style={{ width: 120 }} />
      </div>
      <div className="ms-auto my-auto">
        <Skeleton height={40} style={{ width: 80, borderRadius: 24 }} />
      </div>
    </div>
  </div>
);
